import { ContainerSettings } from '../modular-casino/models/modular-container.models';

export const ContainerConfigs: ContainerSettings = {
    showIcon: true,
    showTitle: true,
    showSubtitle: true,
    maxItems: 10,
    categoryIdentifier: 'home',
    chunkSize: 5,
    swipeSize: 5,
};

export type LobbyType = 'instantCasino' | '';
